import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <path d="M24 37.356L33.24 34.844L34.486 21.288H18.052L17.644 16.78H34.896L35.35 12.358H12.65L13.922 25.714H29.562L29.04 31.446L24 32.78L18.96 31.446L18.644 27.758H14.104L14.762 34.846L24 37.356ZM6 5H42L38.754 41L24 45L9.246 41L6 5Z" />,
  'html'
);
